import { IDataQualityIndicatorItemInfo } from '../../catalog/models/IDataQualityIndicatorItemInfo';
import { IPublishedConnectionUsageInfo } from '../../spacesPlatform/models/IUsageInfo';
import {
  ICreatedItemInfo,
  IDescriptionItemInfo,
  IExplorableItemTypeInfo,
  IFavoriteItem,
  IIdItemInfo,
  IItemStatisticsInfo,
  INamedItemInfo,
  IOwnedItemInfo,
  IProjectItemInfo,
  IPublishedConnectionExtractItemInfo,
  ITaggedItemInfo,
  IUpdatedItemInfo,
} from '../../spacesPlatform/models/resourceInfoParts';

export interface IPublishedConnectionBase extends
  IExplorableItemTypeInfo<'virtualConnection'>,
  ICreatedItemInfo,
  IDataQualityIndicatorItemInfo,
  IDescriptionItemInfo,
  IFavoriteItem,
  IIdItemInfo,
  INamedItemInfo,
  IOwnedItemInfo,
  IProjectItemInfo,
  IPublishedConnectionExtractItemInfo,
  ITaggedItemInfo,
  IUpdatedItemInfo
{
  luid: string;
}

export interface IPublishedConnectionInfo extends
  IPublishedConnectionBase,
  IItemStatisticsInfo<IPublishedConnectionUsageInfo>
{
}

export interface IPublishedConnectionDetailInfo extends
  IPublishedConnectionBase
{
  tables: IPublishedConnectionTableInfo[];
}

export interface IPublishedConnectionDetailWithUsageInfo extends
  IPublishedConnectionDetailInfo,
  IItemStatisticsInfo<IPublishedConnectionUsageInfo>
{
}

export interface IPublishedConnectionTableInfo {
  alias: string;
  databaseName?: string;
  name: string;
  schemaName?: string;
  luid: string;
}

export function isPublishedConnectionInfo(publishedConnection: IExplorableItemTypeInfo): publishedConnection is IPublishedConnectionInfo {
  return (publishedConnection.contentType === 'virtualConnection');
}
